import Cookies from 'js-cookie'
import * as R from 'ramda'
import { get, post } from '@/service/base'

export type ProjectScopeType = 'system' | 'domain' | 'project'

export const ONECLOUD_AUTH_KEY = 'yunionauth'

export function getTokenFromCookie() {
  return Cookies.get(ONECLOUD_AUTH_KEY)
}

export function getScopeFromCookie() {
  return Cookies.get('scope')
}

export function setScopeInCookie(scope: ProjectScopeType) {
  return Cookies.set('scope', scope, { expires: 7 })
}

export function removeScopeInCookie() {
  return Cookies.remove('scope')
}

export function getTenantFromCookie() {
  return Cookies.get('tenant')
}

export function setTenantInCookie(tenant: string) {
  return Cookies.set('tenant', tenant, { expires: 7 })
}

export function removeTenantInCookie() {
  return Cookies.remove('tenant')
}

export function resetCookie() {
  removeTenantInCookie()
  removeScopeInCookie()
}

export async function login(data: NonNullable<unknown>) {
  const _data = { ...data }
  await post(
    '/api/v1/auth/login',
    {
      body: _data,
      cache: 'no-cache',
      method: 'POST',
    },
    {
      prefix: false,
    },
  )
}

export async function logout() {
  await post(
    '/api/v1/auth/logout',
    {
      cache: 'no-cache',
    },
    { prefix: false },
  )
}

export async function getScopedResources() {
  const data = (await get(
    '/api/v1/auth/scoped_resources',
    {
      cache: 'no-cache',
    },
    { prefix: false },
  )) as Record<string, string[]>

  return R.map((item: any) => {
    return R.flatten(R.values(item))
  }, data) as { domain: string[]; system: string[]; user: string[] }
}
